/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HtmlContent } from '../../models/html-content';

export interface DownloadPdfApiV2SubmissionsOrgDownloadPdfPost$Params {
  org: string;
      body: HtmlContent
}

export function downloadPdfApiV2SubmissionsOrgDownloadPdfPost(http: HttpClient, rootUrl: string, params: DownloadPdfApiV2SubmissionsOrgDownloadPdfPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, downloadPdfApiV2SubmissionsOrgDownloadPdfPost.PATH, 'post');
  if (params) {
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

downloadPdfApiV2SubmissionsOrgDownloadPdfPost.PATH = '/api/v2/submissions/{org}/download/pdf';
